import { Card, Flex, Skeleton, Stack, Text } from 'ui';

import { useShowCause, useUserCause } from '../../api';
import { CauseLogo } from './logos/CauseLogo';

interface CauseCardProps extends React.ComponentProps<'div'> {
  cause_uuid?: string;
}

export const CauseCard = ({ cause_uuid, onClick }: CauseCardProps) => {
  const { data: userCause } = useUserCause();
  const { data: cause, isLoading: isCauseLoading } = useShowCause(cause_uuid ?? userCause?.uuid);

  return (
    <Card radius="md" shadow="sm" w="100%" onClick={onClick}>
      <Flex gap="xl" align="center">
        <CauseLogo cause_uuid={cause?.uuid} />
        <Stack gap={4}>
          <Skeleton visible={isCauseLoading}>
            <Text fz="sm" fw={700} lh="17px" color="#403F3B">
              {cause?.name}
            </Text>
          </Skeleton>
          <Skeleton visible={isCauseLoading}>
            <Text fz="xs" lh="15px" color="#767676">
              {cause?.slogan}
            </Text>
          </Skeleton>
        </Stack>
      </Flex>
    </Card>
  );
};
